import { useMutation } from "@tanstack/react-query";
import {
  type CreateRelatedPartyCommandResult,
  type RelatedPartyDto,
  postPartiesPartyPublicIDRelations,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Props = {
  onSuccess?: (publicID: CreateRelatedPartyCommandResult) => void;
  onError?: () => void;
};

export const useCreatePartyRelationMutation = ({
  onSuccess,
  onError,
}: Props = {}) =>
  useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      ({
        data,
        partyPublicID,
      }: {
        data: RelatedPartyDto;
        partyPublicID: string;
      }) => postPartiesPartyPublicIDRelations(data, partyPublicID),
    ),
    onSuccess: (data: CreateRelatedPartyCommandResult) => {
      onSuccess?.(data);
    },
    onError,
  });
